import React, { useEffect } from 'react';
import './textContent.css';
import { useDispatch } from 'react-redux';
import { setChartTitle } from '../../redux/slices/uiSlice';

export default function TextContent({ data }) {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setChartTitle(null));
  }, [dispatch]);

  if (!data) return null;

  const { name, description } = data;

  return (
    <div className="text-content">
      {/* Nombre */}
      {name && <h2 className="text-title">{name}</h2>}

      {/* Descripción */}
      {description && (
        <div className="text-description">
          {description
            .split('\n')
            .filter(para => para.trim() !== '')
            .map((para, idx) => (
              <p key={idx} className="text-paragraph">
                {para}
              </p>
            ))}
        </div>
      )}
    </div>
  );
}
